import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0441e1f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "channel-page" }
const _hoisted_2 = { class: "channel-page__channel" }

import { computed, onMounted } from 'vue'
import useClipboard from 'vue-clipboard3'
import { ElMessage, ElNotification } from 'element-plus'
import { CopyDocument, Download } from '@element-plus/icons-vue'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import { channelSearchItems, createChannelTableColumns } from './channel.config'
import {
  downloadChannelQrCode,
  fetchChannelPage,
  generateChannelUrl
} from './channel.service'
import type { ChannelRecord } from './channel.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'Channel',
  setup(__props) {

const canList = usePermission('customerEvents', 'list')
const canDownloadQrCode = usePermission('customerEvents', 'qrCode')
const { toClipboard } = useClipboard()

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh
} = usePagedCrud({
  createFilters: () => ({ eventName: '' }),
  fetchPage: fetchChannelPage
})

const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)
const tableColumns = computed(() =>
  createChannelTableColumns(canDownloadQrCode)
)

async function copyChannelUrl(row: ChannelRecord) {
  try {
    const url = await generateChannelUrl(row.rowId)
    await toClipboard(url)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (cause) {
    ElNotification({
      title: '复制失败',
      message: cause instanceof Error ? cause.message : '请稍后重试',
      type: 'error'
    })
  }
}

async function saveQrCode(row: ChannelRecord) {
  try {
    const blob = await downloadChannelQrCode(row.rowId)
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.download = `${row.title}.jpg`
    link.href = url
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  } catch (cause) {
    ElMessage.error(cause instanceof Error ? cause.message : '二维码下载失败')
  }
}

onMounted(() => {
  if (canList) load()
})

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: _unref(channelSearchItems),
      loading: _unref(loading),
      onSearch: _unref(search),
      onReset: _unref(reset)
    }, null, 8, ["model", "items", "loading", "onSearch", "onReset"]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "row-key": "rowId",
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: tableColumns.value,
      onPageChange: _unref(changePage),
      onPageSizeChange: _unref(changePageSize),
      onRetry: _unref(refresh)
    }, {
      title: _withCtx(() => [
        _createTextVNode("直播间列表")
      ]),
      channel: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 80,
            src: row.headImgUrl,
            fit: "contain"
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString(row.eventName), 1)
        ])
      ]),
      liveUrl: _withCtx(({ row }) => [
        _createVNode(_component_el_link, {
          href: row.liveUrl,
          type: "primary",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 打开直播间 ")
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      copy: _withCtx(({ row }) => [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: ($event: any) => (copyChannelUrl(row))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CopyDocument), {
              class: "channel-page__button-icon",
              "aria-hidden": "true"
            }),
            _createTextVNode(" 点击复制 ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      rowActions: _withCtx(({ row }) => [
        _createVNode(_component_el_button, {
          type: "text",
          onClick: ($event: any) => (saveQrCode(row))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Download), {
              class: "channel-page__button-icon",
              "aria-hidden": "true"
            }),
            _createTextVNode(" 二维码下载 ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns", "onPageChange", "onPageSizeChange", "onRetry"])
  ]))
}
}

})